<template>
  <span :class="status" class="font-weight-black">
    {{ status | code('CreditPaysRequest.Status') }}
  </span>
</template>

<script>
export default {
  props: ['status'],
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.init {
}
.approve {
  color: $primary;
}
.reject {
  color: $red;
}
.cancel {
}
</style>
